export interface PlanAccessProfile {
  plan?: string;
  trial_info?: {
    trial_days_remaining?: number;
  };
  trial_ends_at?: string;
}

export function isTrialExpired(profile?: PlanAccessProfile | null): boolean {
  if (!profile) return false;

  const plan = (profile.plan || "").toLowerCase();
  const isTrialPlan = plan === "trial" || plan === "trail";

  if (plan === "expired_trial") return true;
  if (!isTrialPlan) return false;
  if (profile.trial_info?.trial_days_remaining !== undefined) {
    return profile.trial_info.trial_days_remaining <= 0;
  }
  if (profile.trial_ends_at) {
    return new Date() > new Date(profile.trial_ends_at);
  }

  return false;
}

export function isToolboxPlan(profile?: PlanAccessProfile | null): boolean {
  return (profile?.plan || "").toLowerCase() === "toolbox";
}

export function areWatchFeaturesLocked(profile?: PlanAccessProfile | null): boolean {
  return isTrialExpired(profile) || isToolboxPlan(profile);
}
